/*@ngInject*/
const NotificationPopupTemplateModel = function () {

    this.notificationPopupTemplate = {};
    this.hasUnsavedChanges = false;
    this.isValid = false;

    this.reset = function () {
        this.notificationPopupTemplate = {};
        this.hasUnsavedChanges = false;
        this.isValid = false;
    };
};

angular.module('ums.configuration')
    .service('notificationPopupTemplateModel', NotificationPopupTemplateModel);
